var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import JSONAPIAdapter from '@ember-data/adapter/json-api';
import { inject as service } from '@ember/service';
import environment from '@square/environment-utils/environment';
const WEEBLY_HOST = environment().isProduction || environment().isSandbox ? 'https://www.weebly.com' : 'https://staging.weebly.net';
let DomainTerm = (_dec = service('chamber/chamber-ajax'), _class = class DomainTerm extends JSONAPIAdapter {
  constructor(args) {
    super(args);
    _initializerDefineProperty(this, "chamberAjax", _descriptor, this);
    _defineProperty(this, "host", WEEBLY_HOST);
    _defineProperty(this, "namespace", 'checkout/api/v2');
    this.useFetch = false;
  }
  pathForType() {
    return 'domains';
  }
  urlForQuery(query, modelName) {
    const {
      userServiceId
    } = query;
    const baseUrl = this.buildURL(modelName);
    return `${baseUrl}/${userServiceId}/extensions`;
  }
  query(store, type, query, recordArray, adapterOptions) {
    // Used to skip chamberajax when using the test or dummy server. Simply checking for the
    // environment would break when running on development mode in either the dummy server or
    // the full local Dashboard, depending on implementation.
    if (this.chamberAjax.notImplemented) {
      return super.query(store, type, query, recordArray, adapterOptions);
    }
    const url = this.urlForQuery(query, type.modelName);
    return this.chamberAjax.ajax(url, 'GET');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "chamberAjax", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { DomainTerm as default };